webpackJsonp([123315765418214],{

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic01.55e1797f.jpg";

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pic = __webpack_require__(30);
	
	var _pic2 = _interopRequireDefault(_pic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Intro = function (_Component) {
	  _inherits(Intro, _Component);
	
	  function Intro() {
	    _classCallCheck(this, Intro);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Intro.prototype.componentDidMount = function componentDidMount() {
	    this.props.onPageIn();
	  };
	
	  Intro.prototype.render = function render() {
	    var _this2 = this;
	
	    var close = _react2.default.createElement('div', { className: 'close', onClick: function onClick() {
	        return _this2.props.navigateWithTimeout('page', '/');
	      } });
	
	    return _react2.default.createElement(
	      'div',
	      { id: 'wrapper' },
	      _react2.default.createElement(
	        'div',
	        { id: 'main' },
	        _react2.default.createElement(
	          'article',
	          { id: 'intro', className: this.props.articleTimeout ? 'timeout' : '' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'major' },
	            'Intro'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'image main' },
	            _react2.default.createElement('img', { src: _pic2.default, alt: '' })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Hi there, I\'m David and welcome to my site. I\'m a full-stack web developer based in West LA. I\u2019ve worked on various projects such as cross-platform mobile application, full-stack web application, and .NET web application. If you want to learn more about my previous projects, please check out my ',
	            _react2.default.createElement(
	              'a',
	              { href: '/work', onClick: function onClick(event) {
	                  return _this2.props.navigateWithTimeout('page', '/work', event);
	                } },
	              'awesome work'
	            ),
	            '.'
	          ),
	          close
	        )
	      )
	    );
	  };
	
	  return Intro;
	}(_react.Component);
	
	Intro.propTypes = {
	  route: _propTypes2.default.object,
	  article: _propTypes2.default.string,
	  articleTimeout: _propTypes2.default.bool,
	  onCloseArticle: _propTypes2.default.func,
	  timeout: _propTypes2.default.bool
	};
	
	exports.default = Intro;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-intro-js-08bc14cfa0427372ecfd.js